import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ENDPOINTS } from '../../api/endPoints';
import { get, post } from '../../api/service/apiService';
import {
  fetchWorkflowStatusRequest,
  fetchWorkflowStatusSuccess,
  fetchWorkflowStatusFailure,
  triggerWorkflowRequest,
  triggerWorkflowSuccess,
  triggerWorkflowFailure,
} from '../slices/workflowTriggerSlice';

interface WorkflowResponse {
  success: boolean;
  message: string;
  data: {
    isSystemGenerated: boolean;
    requestId?: string;
    taskId?: string;
  };
  error: null | string;
}

function* handleFetchWorkflowStatus(action: PayloadAction<{ restaurantId: string }>) {
  try {
    const { restaurantId } = action.payload;
    
    // GET request to fetch workflow status with restaurantId in headers
    const response: { data: WorkflowResponse } = yield call(get, {
      endpoint: ENDPOINTS.workflowStatus,
      headers: {
        'restaurant-id': restaurantId,
      },
    });

    if (response.data.success) {
      yield put(fetchWorkflowStatusSuccess(response.data));
    } else {
      yield put(fetchWorkflowStatusFailure(response.data.error || 'Failed to fetch workflow status'));
    }
  } catch (error: any) {
    yield put(fetchWorkflowStatusFailure(error.message || 'Failed to fetch workflow status'));
  }
}

function* handleTriggerWorkflow(action: PayloadAction<{ restaurantId: string }>) {
  try {
    const { restaurantId } = action.payload;
    
    // POST request to trigger workflow with restaurantId in headers
    const response: { data: WorkflowResponse } = yield call(post, {
      endpoint: ENDPOINTS.workflowTrigger,
      headers: {
        'restaurant-id': restaurantId,
      },
    });

    if (response.data.success) {
      yield put(triggerWorkflowSuccess(response.data));
      // Component will handle navigation to processing and websocket connection
    } else {
      yield put(triggerWorkflowFailure(response.data.error || 'Failed to trigger workflow'));
    }
  } catch (error: any) {
    yield put(triggerWorkflowFailure(error.message || 'Failed to trigger workflow'));
  }
}

export default function* workflowTriggerSaga() {
  yield takeLatest(fetchWorkflowStatusRequest.type, handleFetchWorkflowStatus);
  yield takeLatest(triggerWorkflowRequest.type, handleTriggerWorkflow);
}
